import { resolveMediaUrl } from "../../lib/api";
import { Card } from "../ui/card";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Plus, Link2, Upload, ImageIcon } from "lucide-react";
import { VideoListItem } from "./videos/VideoListItem";
import { useVideoManager } from "../../hooks/useVideoManager";

export const AdminVideos = () => {
  const {
    videos, mode, setMode, newTitle, setNewTitle, newUrl, setNewUrl, newThumbnail,
    saving, busyKey, addLink, handleFileUpload, handleNewThumbnailUpload,
    handleExistingThumbnailUpload, removeVideo, save,
  } = useVideoManager();

  return (
    <Card className="p-6 space-y-6" data-testid="admin-videos-panel">
      <h3 className="font-semibold">Videos destacados</h3>
      <p className="text-sm text-muted-foreground">
        Agrega un enlace (YouTube, Vimeo, Google Drive) o sube tu propio archivo de video (máx. 50MB). Puedes agregar una imagen de portada que se mostrará como miniatura con un botón de play.
      </p>

      <div className="flex gap-2">
        <button
          data-testid="admin-video-mode-link"
          onClick={() => setMode("link")}
          className={`flex items-center gap-1 px-3 py-1.5 text-xs rounded border ${mode === "link" ? "bg-primary text-primary-foreground" : ""}`}
        >
          <Link2 size={14} /> Enlace
        </button>
        <button
          data-testid="admin-video-mode-upload"
          onClick={() => setMode("upload")}
          className={`flex items-center gap-1 px-3 py-1.5 text-xs rounded border ${mode === "upload" ? "bg-primary text-primary-foreground" : ""}`}
        >
          <Upload size={14} /> Subir archivo
        </button>
      </div>

      <div className="flex flex-wrap gap-3 items-end">
        <Input data-testid="admin-video-new-title" placeholder="Título (opcional)" value={newTitle} onChange={(e) => setNewTitle(e.target.value)} className="w-48" />

        <label data-testid="admin-video-new-thumbnail-label" className="shrink-0 flex items-center gap-1 border rounded px-3 py-2 text-xs cursor-pointer hover:bg-secondary/50">
          {newThumbnail ? (
            <img src={resolveMediaUrl(newThumbnail)} alt="Portada" className="h-6 w-10 object-cover rounded" />
          ) : (
            <ImageIcon size={14} />
          )}
          {busyKey === "new" ? "Subiendo..." : "Portada"}
          <input data-testid="admin-video-new-thumbnail-input" type="file" accept="image/*" className="hidden" onChange={handleNewThumbnailUpload} disabled={busyKey === "new"} />
        </label>

        {mode === "link" ? (
          <>
            <Input data-testid="admin-video-new-url" placeholder="URL del video" value={newUrl} onChange={(e) => setNewUrl(e.target.value)} className="flex-1 min-w-[220px]" />
            <Button data-testid="admin-video-add-button" onClick={addLink}><Plus size={16} className="mr-1" /> Agregar</Button>
          </>
        ) : (
          <label data-testid="admin-video-upload-label" className="flex items-center gap-2 border-2 border-dashed rounded-lg px-4 py-2 cursor-pointer hover:bg-secondary/50 text-sm">
            <Upload size={16} /> {busyKey === "video" ? "Subiendo..." : "Elegir archivo de video"}
            <input data-testid="admin-video-upload-input" type="file" accept="video/mp4,video/quicktime,video/webm" className="hidden" onChange={handleFileUpload} disabled={busyKey === "video"} />
          </label>
        )}
      </div>

      <div className="space-y-2">
        {videos.map((v, idx) => (
          <VideoListItem
            key={`${v.url}-${idx}`}
            v={v}
            idx={idx}
            uploadingThumbFor={busyKey}
            onThumbnailUpload={(e) => handleExistingThumbnailUpload(e, idx)}
            onRemove={() => removeVideo(idx)}
          />
        ))}
      </div>

      <Button data-testid="admin-videos-save-button" onClick={save} disabled={saving}>
        {saving ? "Guardando..." : "Guardar videos"}
      </Button>
    </Card>
  );
};
